module.exports = __webpack_public_path__ + "img/bule6.f4bdde44.png";